import { SelectOption } from '@/models/generics'
import { UUID, Entry } from '@Protium/vue-ozone-utils/types'
import { WritableComputedRef } from 'vue'
import { Fulfillment, OrderStatusInfo, ShipmentLabel } from '@/models/interfaces/order'
import { Address } from '@/models/generics'

export enum ProductView {
  Default = 'default',
  Cards = 'cards'
}

export interface ProductSelection {
  id: string, // order-product-id, not sys.id
  quantity: number
}

export enum ReplacementType {
  Default = 'default',
  Compensation = 'compensation',
  Credit = 'credit'
}

export interface ReplacementInstruction {
  cancel?: Array<string> | null, // product id's to replace & mark as cancelled
  replacements?: Array<{id: UUID, quantity: number}> | null, // new product/stock-item ids to add and mark as "replacement"
  reason?: string | null,
  type?: ReplacementType | null
}

export interface OrderListProductState {
  loading: boolean,
  show: boolean,
  edit: boolean,
  diff: boolean,
  showPackingOptions?: string,
  replace: {
    products: WritableComputedRef<Array<any> | null>,
    reason: string | null,
    type: SelectOption | null // ReplacementType.Default | null
  },
  items: Array<Entry>,
  selection: Array<any>
}

export interface ProductDragState {
  dragging?: {packIndex: number, componentIndex: number}, // currently dragged element
  assignTarget?: number, // packing item index the currently dragged element should be assign to (set on drag-over)
  dragId?: string,
  handler?(product?:any, index?:number, event?:any): any
}

export interface OperationalData {
  fulfillments?: {
    items?: Array<Fulfillment>,
    labels?: Array<ShipmentLabel>
  },
  address?: Address,
  statusInfo?: OrderStatusInfo,
  notes?: string,
  meta?: Record<string, any>
}
